import React, { StrictMode, Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { ChakraProvider } from '@chakra-ui/core';
import theme from '@Theme';
import i18n from '@I18n';
import store from '@Store';
import router from '@Router';

import 'nprogress/nprogress.css';

render(
  <StrictMode>
    <Provider store={store}>
      <Suspense fallback={<></>}>
        <I18nextProvider i18n={i18n}>
          <ChakraProvider theme={theme}>
            <BrowserRouter>
              {renderRoutes(router)}
            </BrowserRouter>
          </ChakraProvider>
        </I18nextProvider>
      </Suspense>
    </Provider>
  </StrictMode>,
  document.getElementById('root'),
);
